import { Expose, instanceToPlain, plainToInstance, Transform } from 'class-transformer'
import type { FamilyResponse as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'
import { map } from 'lodash'
import FamilyMemberResponse from '@/services/api/transformers/FamilyMemberResponse'

export type SerializedFamilyResponse = Model

export default class FamilyResponse implements CamelCaseKeys<SerializedFamilyResponse> {
    @Expose({ name: 'family_name' })
    familyName?: Model['family_name']

    @Expose({ name: 'family_photo' })
    familyPhoto?: Model['family_photo']

    @Expose({ name: 'family_id' })
    familyId?: Model['family_id']

    @Expose({ name: 'members' })
    @Transform(({ value }) => map(value, item => plainToInstance(FamilyMemberResponse, item)), {
        toClassOnly: true
    })
    @Transform(({ value }) => map(value, item => instanceToPlain(item)), { toPlainOnly: true })
    members?: FamilyMemberResponse[]

    constructor(values: FamilyResponse) {
        Object.assign(this, values)
    }
}
